import {Text, View} from "@react-pdf/renderer";
import {styles} from "../../StylesPdfReport";

const AboutSection = () => {
    return (
        <>
            <View style={styles.sectionAbout}>
                <Text style={styles.h1}>Date generale despre raport și test</Text>
                <View style={styles.subsection}>
                    <View style={styles.subsectionContent}>
                        <Text style={styles.p}>
                            Acest raport a fost realizat în urma parcurgerii Testului Național de Alfabetizare
                            Matematică.
                        </Text>
                        <Text style={styles.p}>
                            Alfabetizarea matematică este definită (cf. OECD - PISA 2021 Mathematics Framework) ca fiind
                            capacitatea unei persoane de a raționa matematic și de a formula, folosi și interpreta matematica
                            pentru a rezolva probleme într-o varietate de contexte din lumea reală. Ea se referă la un set de
                            competențe care permit persoanelor să opereze cu valori numerice și abstracte, măsurători, forme și
                            dimensiuni, date și variabile în mod aplicat și versatil, în orice aspect al vieții.
                        </Text>
                        <Text style={styles.p}>
                            Testul Național de Alfabetizare Matematică (TNAM) a fost dezvoltat pe baza modelului care stă la baza
                            testului de matematică din cadrul NAEP (National Assessment of Educational Progres), care este
                            testul național folosit în SUA pentru urmărirea progresului elevilor și care se aplică în clasele 4,
                            8 și 12.
                        </Text>
                        <Text style={styles.p}>
                            Competențele de alfabetizare matematică sau numerație sunt evaluate în TNAM pe cinci mari categorii
                            de conținut:
                        </Text>
                        <Text style={styles.p}>
                            1.Proprietăți ale numerelor și Operații cu numerele
                            <br/>
                            2.Măsurare
                            <br/>
                            3.Geometrie
                            <br/>
                            4.Analiza datelor, Statistică și Probabilități
                            <br/>
                            5.Algebră
                        </Text>
                        <Text style={styles.p}>
                            Acest test este diferit de testele de matematică, întrucât se referă la capacitatea de a opera cu
                            numere, măsurători, caracteristici ale obiectelor, date și variabile în situații aplicate, nu doar
                            teoretice. Alfabetizarea matematică se referă la stăpânirea acestor concepte pentru a deservi unor
                            scopuri din viața reală. În acest sens, TNAM este un instrument de evaluare independent de programa
                            școlară, dar este totodată potrivit pentru vârsta elevului testat.
                        </Text>
                    </View>
                </View>
                <View style={styles.subsection}>
                    <Text style={styles.h3}>Componența și utilitatea raportului</Text>
                    <View style={styles.subsectionContent}>
                        <Text style={styles.p}>
                            Acest raport conține informații care pot fi utile pentru elevul testat, părinții/familia sa,
                            respectiv profesori sau orice altă persoană implicată în educația elevului. Mai specific, în acest
                            raport pot fi găsite următoarele informații:
                        </Text>
                        <Text style={styles.p}>
                            <Text style={{fontWeight: 600}}>Secțiunea introductivă</Text> este cea pe care o parcurgeți acum și care conține
                            informații generale despre TNAM și raportul rezultat în urma testării.
                        </Text>
                        <Text style={styles.p}>
                            <Text style={{fontWeight: 600}}>Definirea domeniilor de conținut</Text> este realizată în termeni ușor de înțeles
                            chiar și de către elevi și este de natură să ofere context în interpretarea rezultatelor.
                        </Text>
                        <Text style={styles.p}>
                            <Text style={{fontWeight: 600}}>Graficele cu scoruri</Text> prezintă scorul elevului într-un sistem de centile.
                            Scorul centilă arată modul în care orice elev testat se compară cu toți ceilalți elevi din
                            România care sunt în același an școlar cu acesta. De exemplu, pentru un elev care se află în a 60-a
                            centilă, vom spune că 40% dintre elevii din România (de aceeași vârstă sau din aceeași
                            clasă) au performanțe mai bune decât a sa, în timp ce 60% au performanțe mai slabe sau egale cu cea a
                            elevului testat. În același timp, un elev care se află la centila 90 are doar 10% din populația școlară
                            comparabilă cu performanță mai bună decât a sa, iar 90% au performanțe mai slabe, acesta
                            fiind, așadar, un scor foarte mare. În urma testării, elevul va primi scorul pentru toate componentele
                            evaluate, atât cele 5 categorii largi de conținut, cât și subdimensiunile acestora.
                        </Text>
                        <Text style={styles.p}>
                            Pe lângă punctaj, raportul conține informații și despre categoria de performanță în care se
                            încadrează elevul testat pentru cele 5 categorii largi de conținut. Categoriile de scoruri
                            sunt următoarele: Nivel de bază (scor 1-40), Nivel avansat (scor 41-70) și Nivel expert
                            (scor 71-100). Categoria de performanță în care se încadrează punctajul elevului testat este
                            evidențiată și conține descrieri generale legate de cunoștințele și abilitățile sale.
                        </Text>
                        <Text style={styles.p}>
                            Deși TNAM este un instrument de evaluare robust, pentru decizii majore legate de educația
                            elevului, se recomandă întotdeauna coroborarea de informații din surse multiple.
                        </Text>
                    </View>
                </View>
            </View>
        </>
    )
}

export default AboutSection;